export const identity = <T>(v: T): T => v;
